export const getFilePath = (file: File): string => {
  //@ts-ignore
  return file?.path?.startsWith("/") ? file?.path.slice(1) : file.webkitRelativePath;
};
